import { toast } from 'react-toastify'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handlerErrorSimulacao(error: any, defaultMessage?: string) {
  if (
    (error?.message || (error?.messages?.length > 0 && error?.messages)) &&
    !error?.stack
  ) {
    if (error?.messages?.length > 0) {
      error?.messages.map((e: string) => {
        toast.warn(e, {
          className: 'text-break',
          autoClose: false
        })
      })
    } else {
      toast.warn(error?.message, {
        className: 'text-break',
        autoClose: false
      })
    }
  } else {
    defaultMessage
      ? toast.warn(defaultMessage, {
          className: 'text-break',
          autoClose: false
        })
      : toast.warn('Não foi possível!', {
          className: 'text-break',
          autoClose: false
        })
  }
}
